import type { ICategory } from "app/common/services/categoryService.types";
import { categoryClassIconFilter } from "app/filters/ngFilters";
import { GRID_UPGRADE_MOCK_VALUE } from "app/pages/sales-intelligence/constants/common";

import type { CompetitiveLandscapeCategory, CompetitiveLandscapeChildCategory } from "../types/dto";

export const getCategoryNameForTracking = (category: ICategory): string =>
    category ? category.forApi.replace("~", " > ").replace("_", " ") : "Clear Filter";

const convertCategory = (
    category: CompetitiveLandscapeCategory | CompetitiveLandscapeChildCategory,
    parentId = "",
) => {
    const { text, id, children } = category as CompetitiveLandscapeCategory;
    return {
        text,
        id,
        isCustomCategory: false,
        isChild: !children || children.length === 0,
        icon: categoryClassIconFilter()(id),
        forApi: `${parentId ? `${parentId}~` : ``}${id}`,
    };
};

export const getCategoriesOptions = (categories: CompetitiveLandscapeCategory[]) =>
    categories.reduce((result, category) => {
        if (!category || category.text === GRID_UPGRADE_MOCK_VALUE) {
            return result;
        }

        if (Array.isArray(category.children) && category.children.length > 0) {
            return [
                ...result,
                convertCategory(category),
                ...category.children.map((child) => convertCategory(child, category.id)),
            ];
        }

        return [...result, convertCategory(category)];
    }, []);
